<template>
    <el-input :value="value2" readonly="readonly" ></el-input>    
</template>
<script>
export default {
    name:'l-code',
    props: {
        value:String,
        code:String,
        client:{
            type:Boolean,
            default:false
        }
    },
    watch: {
        value:{
            handler(newVal){
                if(this.$validatenull(newVal)){
                    this.setCode()
                }
            },
            immediate: true
        }
    },
    computed:{
        value2:{
            get(){
                if(this.$validatenull(this.value) || this.value.indexOf('learun_code_') != -1){
                    return '保存时生成'
                }
                return this.value
            },
            set(val){
                this.$emit('input',val)
            }
        }
    },
    methods:{
        async setCode(){
            if(this.client){
                if(!this.$validatenull(this.code) && this.lr_getCode){
                    this.value2 = await this.lr_getCode(this.code)
                }
            }else{
                this.value2 = `learun_code_${this.code}|${this.$uuid()}`
            }
        }
    }
}
</script>